import { Card, Divider, Row, Col, Space, Timeline, Typography, Tag } from 'antd';

import ChargeOffModal from './ChargeOffModal';
import ReverseChargeOffModal from './ReverseChargeOffModal';
import BloomAccountUpdateModal from './BloomAccountUpdateModal';
import BloomAccountStatus from './BloomAccountStatus';
import PatchStatementsModal from '../StatementPatch/PatchStatementsModal';
import StatementFurnishment from '../StatementPatch/StatementView';
import AccountDeleteModal from '../AccountDeleteModal';
import { indexOf } from 'lodash';
import { isSupportManager, isSupportEngineer, isFurnishingAdmin } from '../../../../helpers/genericHelper';
import Data from '../../../CustomText/data';

const { Text } = Typography;

const LATE_PAYMENT_DAYS_LIMIT = 29;

export default function AccountDetails({ fullName, account, isCC = false, refresh, userId, creditCards }) {

  const shouldShowDeleteAccount = (accountStatus) => {
    return indexOf(['DELETED_CONFIRMED_FRAUD', 'DELETED'], accountStatus) === -1;
  }

  const shouldShowChargeOffAccount = (accountStatus) => {
    return indexOf(['DELETED_CONFIRMED_FRAUD', 'DELETED', 'CHARGE_OFF'], accountStatus) === -1;
  }

  const groupStatementsByReportingCycle = (statements) => {
    return statements.reduce((acc, statement) => {
      const reportingCycle = statement.reportingCycle;
      if (!acc[reportingCycle]) {
        acc[reportingCycle] = [];
      }
      acc[reportingCycle].push(statement);
      return acc;
    }, {});
  }

  const statements = groupStatementsByReportingCycle(account?.statements || []);
  const reportingCycles = Object.keys(statements).reverse();

  const accountStatements = account?.statements || [];
  const hasLateStatement = accountStatements.some((statement) => Number(statement.daysDelinquent) > LATE_PAYMENT_DAYS_LIMIT);
  const latePaymentTag = accountStatements.length === 0
    ? { color: 'default', value: 'No statements' }
    : { color: hasLateStatement ? 'error' : 'success', value: hasLateStatement ? 'YES' : 'NO' };

  console.log('statements', statements, 'reportingCycles', reportingCycles, 'creditCards', creditCards)

  return (
    <>
      <Card
        bordered={false}
        style={{ width: '100%' }}>
        <Row className="subscription-cancelled-card bottom-bordered-card">
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Space className="furnishing-highlights" direction="vertical" style={{width: '100%'}}>
              <Row>
                <Col span="4">
                  <Data title="Bloom Account ID" value={account?.accountId} copyable />
                </Col>

                <Col span="4">
                  <Data title="Ava Product ID" value={account?.productId} copyable/>
                </Col>
                
                <Col span="4">
                  <Data title="Tradeline Account #" value={account?.accountNumber} copyable/>
                </Col>
                <Col span="4">
                  {
                    !isCC && <>
                      <Data title="SB Type" value={account?.productType} />
                    </>
                  }
                </Col>
                
                <Col span="6">
                  <Space direction="vertical" style={{ width: '100%' }}>
                    { isSupportManager() && shouldShowDeleteAccount(account?.accountStatus) && 
                        <AccountDeleteModal refresh={refresh} furnishingAccount={account} creditCard={isCC} creditCardTransactions={isCC ? creditCards : []} />
                    }
                    {
                      isSupportManager()
                      && shouldShowDeleteAccount(account?.accountStatus)
                      && <PatchStatementsModal
                        statements={account?.statements}
                        accountId={account?.accountId}
                        productId={account?.productId}
                        userId={userId}
                        accountType="Credit Card"
                        userName={fullName}
                        refresh={refresh} />
                    }
                    
                    </Space>
                </Col>
              </Row>
              <Row>
                <Col span="24">
                  <Data isTag tagColor={account?.accountStatus === "CURRENT" ? "success" : "error"} title="Account Status" value={account?.accountStatus} />
                  <Data isTag tagColor={latePaymentTag.color} title="Late Payment Reported" value={latePaymentTag.value} />
                  <Data isTag tagColor="success" title="Open Date" value={account?.openDate ? (account?.openDate) : null} />
                  <Data isTag tagColor={account?.closureDate ? "error" : "default"}title="Closure Date" value={account?.closureDate ? (account?.closureDate) : null} />
                  <Data isTag tagColor="processing" title="Furnishment Day" value={account?.furnishmentDay} />
                  {
                      isSupportManager()
                      && <BloomAccountUpdateModal furnishingAccount={account} refresh={refresh}/>
                    }
                </Col>
              </Row>
              <Row>
                <Col span="16">
                  <BloomAccountStatus productId={account?.productId} reloadData={refresh}/>
                </Col>
                <Col span="8">
                  
                </Col>
              </Row>
            </Space>
          </Col>
        </Row>
        <Card bordered title="Statements">
          <Row>
            <Col span={23} offset={1}>
              <Timeline mode="left">
                <Space direction='vertical' style={{ width: "100%" }}>
                  {
                    reportingCycles.map((reportingCycle, i) => {
                      return <Timeline.Item key={i}>
                        
                        <Space direction='vertical' style={{ width: "100%" }}>
                          <Text type="secondary" strong>Reporting Cycle: {reportingCycle}</Text>
                          {
                            statements[parseInt(reportingCycle)].map((statement, j) => {
                              return <StatementFurnishment
                                statement={statement}
                                key={j}
                                shouldShowDelete={shouldShowDeleteAccount(account?.accountStatus)}
                                type={isCC ? 'creditCard' : 'savingsBuilder'}
                                allowDownload={true}
                                />
                            })
                          }
                          <Divider />
                        </Space>
                      </Timeline.Item>
                    })
                  }
                  { reportingCycles && reportingCycles.length === 0 && <Text strong type="secondary">No statements found</Text> }
                </Space>
              </Timeline>
            </Col>
          </Row>
        </Card>
      </Card>
    </>
  )
}